import { ViewportProps } from 'react-map-gl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  Actions,
  selectIsSearchArea,
  selectMapViewport,
} from '@pass-frontend/common/offerings/data-access';

export const useMapViewport = () => {
  const dispatch = useDispatch();

  const selectedMapViewport = useSelector<unknown, ViewportProps>(
    selectMapViewport,
    shallowEqual,
  );

  const viewportIsSearchArea = useSelector<unknown, boolean>(
    selectIsSearchArea,
    shallowEqual,
  );

  const updateMapViewport = (dataBounds: ViewportProps) => {
    dispatch(Actions.updateMapViewport(dataBounds));
  };

  const updateIsSearchArea = (payload: boolean) => {
    dispatch(Actions.updateViewportIsSearchArea(payload));
  };

  return {
    selectedMapViewport,
    viewportIsSearchArea,
    updateMapViewport,
    updateIsSearchArea,
  };
};

export default useMapViewport;
